import { render, staticRenderFns } from "./NavItemDropdown.vue?vue&type=template&id=3728f5c8&"
import script from "./NavItemDropdown.vue?vue&type=script&lang=js&"
export * from "./NavItemDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports